var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--blue" }, [
    _c("div", { staticClass: "c-survey__content c-survey__content--padding" }, [
      _c("main", {
        staticClass: "c-survey__html",
        domProps: { innerHTML: _vm._s(_vm.summary.content) },
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "white-text" }, [_vm._v("Your choices:")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-survey__grid c-survey__grid--summary-choices" },
        [
          _c(
            "div",
            {
              staticClass: "c-survey__choice-wrapper",
              style: { backgroundColor: _vm.sections.sectionOne.sectionColour },
            },
            [
              _c("h3", { staticClass: "white-text" }, [
                _vm._v(_vm._s(_vm.sections.sectionOne.label)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-survey__choice-content" }, [
                _vm.sections.sectionOne.imageFile
                  ? _c("img", {
                      staticClass: "c-survey__choice-image",
                      attrs: { src: _vm.sections.sectionOne.imageFile },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "c-survey__choice-tokens" }, [
                  _c("h2", { staticClass: "white-text" }, [
                    _vm._v(_vm._s(_vm.submissionData.sectionOneTokens)),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-survey__choice-wrapper",
              style: { backgroundColor: _vm.sections.sectionTwo.sectionColour },
            },
            [
              _c("h3", { staticClass: "white-text" }, [
                _vm._v(_vm._s(_vm.sections.sectionTwo.label)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-survey__choice-content" }, [
                _vm.sections.sectionTwo.imageFile
                  ? _c("img", {
                      staticClass: "c-survey__choice-image",
                      attrs: { src: _vm.sections.sectionTwo.imageFile },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "c-survey__choice-tokens" }, [
                  _c("h2", { staticClass: "white-text" }, [
                    _vm._v(_vm._s(_vm.submissionData.sectionTwoTokens)),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-survey__choice-wrapper",
              style: {
                backgroundColor: _vm.sections.sectionThree.sectionColour,
              },
            },
            [
              _c("h3", { staticClass: "white-text" }, [
                _vm._v(_vm._s(_vm.sections.sectionThree.label)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-survey__choice-content" }, [
                _vm.sections.sectionThree.imageFile
                  ? _c("img", {
                      staticClass: "c-survey__choice-image",
                      attrs: { src: _vm.sections.sectionThree.imageFile },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "c-survey__choice-tokens" }, [
                  _c("h2", { staticClass: "white-text" }, [
                    _vm._v(_vm._s(_vm.submissionData.sectionThreeTokens)),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "white-text" }, [
        _vm._v(
          "You also selected '" +
            _vm._s(_vm.questionYesNo) +
            "' " +
            _vm._s(_vm.summary.questionDescription)
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "c-survey__content c-survey__content--padding c-survey__content--white-bg",
      },
      [
        _c("main", { staticClass: "c-survey__html" }, [
          _c("h1", [_vm._v("Outcome")]),
          _vm._v(" "),
          _vm.displayedOutcome
            ? _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.outcomes[_vm.displayedOutcome]),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.submissionData.questionAnswer
            ? _c("div", {
                domProps: { innerHTML: _vm._s(_vm.outcomes.questionYes) },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.submissionData.questionAnswer
            ? _c("div", {
                domProps: { innerHTML: _vm._s(_vm.outcomes.questionNo) },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "c-survey__actionbutton-row c-survey__actionbutton-row--right",
          },
          [
            _c("ActionButton", {
              attrs: {
                title: _vm.summary.summaryNextLabel,
                buttonAction: "submit",
                nextView: _vm.settings.feedbackEnabled
                  ? "FeedbackView"
                  : "ThankyouView",
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "c-survey__content-spacer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }